import { forwardRef } from "react";
import { Phone } from "lucide-react";
import { trackPhoneClick } from "@/lib/tracking";
import { cn } from "@/lib/utils";

interface PhoneLinkProps {
  location: string;
  className?: string;
  showIcon?: boolean;
  showText?: boolean;
  iconClassName?: string;
}

const PhoneLink = forwardRef<HTMLAnchorElement, PhoneLinkProps>(
  ({ location, className, showIcon = true, showText = true, iconClassName, ...props }, ref) => {
    return (
      <a
        ref={ref}
        href="tel:+16022820383"
        onClick={() => trackPhoneClick(location)}
        className={cn("inline-flex items-center gap-1.5 transition-colors", className)}
        aria-label="Call (602) 282-0383"
        {...props}
      >
        {showIcon && <Phone className={cn("w-4 h-4 shrink-0", iconClassName)} />}
        {showText && "(602) 282-0383"}
      </a>
    );
  }
);

PhoneLink.displayName = "PhoneLink";

export default PhoneLink;
